import React from "react";

// Parallax
import { Parallax } from "react-parallax";

// Images
import TwoBecomeOne from "../../image/two-become-one.jpg";

// Hooks
import useDevice from "../../hooks/useDevice";

// Components
import { Typography, Box, Fade } from "@mui/material";

const Home = () => {
  const { device } = useDevice();

  return (
    <Parallax
      bgImage={TwoBecomeOne}
      strength={300}
      className={`home-${device}`}
    >
      <Box className="vjc_main-home">
        <Fade in={true} timeout={1000}>
          {<Typography variant="h2" style={{ textShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)", }}>TWO BECOME ONE</Typography>}
        </Fade>
        <Fade in={true} timeout={2000}>
          {<Typography variant="h5" style={{ textShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)", fontFamily: 'Amalfi Coast, sans-serif' }}>Jansen & Cristina</Typography>}
        </Fade>
        <Fade in={true} timeout={3000}>
          <div className="home-bible-verse" style={{ textShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)", }}>
            <span>1 Corinthians 16:14</span><br />
            <span>Let all that you do be done in love</span><br />
          </div>
        </Fade>


      </Box>
    </Parallax>
  );
};

export default Home;
